var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"sm0":"","md7":""}},[_c('v-card',{staticClass:"banner_guest",attrs:{"flat":"","tile":"","img":'/static/ContactBanner.png'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }